module.exports = __webpack_public_path__ + "static/media/inventory.006e5f4b.png";